var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_uid.js
// module id = ../../../../core-js/library/modules/_uid.js
// module chunks = 7